require('./bootstrap');

/* Begin: toTop */
$(function () {
    $(document.body).append('<a class="to-top"></a>')

    let toTop = $('.to-top')

    toTop.hide()

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            toTop.fadeIn()
        } else {
            toTop.fadeOut()
        }
    })

    toTop.click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 500)
        return false
    })
});
/* End: toTop */

/* Begin: Page Scrollbar and Wheel Enable/Disable */
const scrollLock = {
    lock: function () {
        //$(document).on('scroll mousewheel DOMMouseScroll', stopWheel);
        $(document.body).addClass('scroll-lock');
    },
    unlock: function () {
        //$(document).off('scroll mousewheel DOMMouseScroll', stopWheel);
        $(document.body).removeClass('scroll-lock');
    }
};
/* End: Page Scrollbar Enable/Disable */

/* Begin: Header menu responsive action */
$(function () {
    $(document).on('click', 'header .menu-toggle', function (e) {
        e.preventDefault();

        $('body').toggleClass('mobile-menu-toggle');

        scrollLock.lock();
    });

    let mobileMenuClose = function () {
        $('body').removeClass('mobile-menu-toggle');
        scrollLock.unlock();
    };

    $(document.body).click(function (e) {
        if ($(e.target).closest('header .menu-toggle, .mobile-menu').length === 0) {
            mobileMenuClose();
        }
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            mobileMenuClose();
        }
    });
});
/* End: Header menu responsive action */

/* Begin: Slides */
$(function () {
    const createMainSlides = function () {
        const main_slides = $('.main-slides');

        if (main_slides.length) {
            let bLazy = new Blazy({
                container: '.main-slides',
                selector: '.b-lazy',
                loadInvisible: true,
            })

            main_slides.on('afterChange', function () {
                bLazy.revalidate();
            });

            let fade_slide = true;
            if (main_slides.data('animation') === 'slide') {
                fade_slide = false;
            }

            main_slides.not('.slick-initialized').slick({
                infinite: true,
                arrows: !!main_slides.data('arrows'),
                dots: !!main_slides.data('dots'),
                appendArrows: $('.main-slides-nav > .container > .arrows'),
                appendDots: $('.main-slides-nav > .container > .dots'),
                adaptiveHeight: true,
                slidesToShow: 1,
                autoplay: !!main_slides.data('autoplay'),
                autoplaySpeed: main_slides.data('speed') ? main_slides.data('speed') : 6000,
                pauseOnHover: !!main_slides.data('hover-pause'),
                fade: fade_slide,
                cssEase: 'linear',
            });

            main_slides.slickAnimation();
        }
    }

    createMainSlides();
    $(window).on('resize', createMainSlides);

    let createNewProductsCarousel = function () {
        const new_products_carousel = $('.new-products-carousel');

        if (new_products_carousel.length) {
            let bLazy = new Blazy({
                container: '.new-products-carousel',
                selector: '.b-lazy',
                loadInvisible: true,
            })

            new_products_carousel.on('afterChange', function () {
                bLazy.revalidate();
            });

            new_products_carousel.not('.slick-initialized').slick({
                infinite: true,
                adaptiveHeight: false,
                arrows: !!new_products_carousel.data('arrows'),
                dots: !!new_products_carousel.data('dots'),
                appendArrows: $('.new-products-carousel-nav > .arrows'),
                appendDots: $('.new-products-carousel-nav > .dots'),
                autoplay: !!new_products_carousel.data('autoplay'),
                autoplaySpeed: new_products_carousel.data('speed') ? new_products_carousel.data('speed') : 6000,
                pauseOnHover: !!new_products_carousel.data('hover-pause'),
                cssEase: 'linear',
                slidesToShow: 10,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 2160,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 2048,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 1920,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 1800,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 1620,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ],
            })

            new_products_carousel.slickAnimation();
        }
    }

    createNewProductsCarousel();
    $(window).on('resize', createNewProductsCarousel);

    const createProductSlides = function () {
        const container = $('.product-slides');
        if (container.length) {
            container.slick({
                infinite: true,
                adaptiveHeight: true,
                arrows: true,
                dots: false,
                fade: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        }
    };

    createProductSlides();
});
/* End: Slides */

/* Begin: External URLs */
$(function () {
    $(document).on('click', 'a.external', function () {
        window.open($(this).attr('href'))
        return false
    });
});
/* End: External URLs */

/* Begin: Captcha refresh */
const captchaRefresh = function (img, input) {
    input.val('');

    img.addClass('process');

    axios.post(img.data('url'))
        .then((response) => {
            img.prop('src', response.data.url);
            img.removeClass('process');
        });
}

$(function () {
    $(document).on('click', '.captcha-img', function () {
        let img = $(this);
        let form = img.parents('form');
        let input = form.find('input[name="captcha"]');

        captchaRefresh(img, input);
        input.focus();
    })
})
/* End: Captcha refresh */

/* Begin: Map */
$(function () {
    let $map = $('.map');
    let latitude = $map.data('latitude');
    let longitude = $map.data('longitude');
    let position = [latitude, longitude];
    let icon = $map.data('marker-icon');
    let title = $map.data('title');

    $map.gmap3({
        map: {
            options: {
                center: position,
                zoom: 17,
                panControl: false,
                zoomControl: true,
                draggable: true,
                scrollwheel: false,
                scaleControl: true,
                styles: [{
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [{"saturation": -100}, {"gamma": 0.5}],
                }],
            }
        },
        marker: {
            values: [
                {latLng: [latitude, longitude], data: title, options: {icon: icon}},
            ],
            options: {
                draggable: false
            },
        },
        overlay: {
            latLng: position,
            options: {
                content: '<div class="map-overlay">' + title + '</div>',
                offset: {
                    y: 5,
                    x: 0
                },
            },
        },
    });
});
/* End: Map */

/* Begin: Brands & Models form */
(() => {
    const elements = $('[data-brands-models]');
    if (elements.length > 0) {
        $.each(elements, function () {
            const brandSelect = $(this).find('select[data-brand]');
            const modelSelect = $(this).find('select[data-model]');

            brandSelect.on('change', function () {
                const brandId = $(this).find('option:selected').val();

                modelSelect
                    .empty()
                    .append(new Option(modelSelect.data('placeholder'), '', true, true))
                    .prop('disabled', true)
                    .trigger('change');

                if (brandId) {
                    axios
                        .get(`/srv/shared/models/${brandId}`)
                        .then((response) => {
                            if (response.data.length > 0) {
                                response.data.forEach(item => {
                                    modelSelect
                                        .append(new Option(item.name, item.id, false, false))
                                        .trigger('change');
                                });

                                modelSelect.prop('disabled', false);
                            } else {
                                modelSelect.prop('disabled', true);
                            }
                        })
                    ;
                } else {
                    modelSelect.prop('disabled', true);
                }
            });
        });
    }
})();
/* End: Brands & Models form form */

/* Begin: Cities & Districts form */
(() => {
    const elements = $('[data-cities-districts]');
    if (elements.length > 0) {
        $.each(elements, function () {
            const citySelect = $(this).find('select[data-city]');
            const districtSelect = $(this).find('select[data-district]');

            citySelect.on('change', function () {
                const cityId = $(this).find('option:selected').val();

                districtSelect
                    .empty()
                    .append(new Option(districtSelect.data('placeholder'), '', true, true))
                    .prop('disabled', true)
                    .trigger('change');

                if (cityId) {
                    axios
                        .get(`/srv/shared/districts/${cityId}`)
                        .then(response => {
                            if (response.data.length > 0) {
                                response.data.forEach(item => {
                                    districtSelect
                                        .append(new Option(item.name, item.id, false, false))
                                        .trigger('change');
                                });

                                districtSelect.prop('disabled', false);
                            } else {
                                districtSelect.prop('disabled', true);
                            }
                        })
                    ;
                } else {
                    districtSelect.prop('disabled', true);
                }
            });
        });
    }
})();
/* End: Cities & Districts form */

/* Begin: products */
(() => {
    $(document).on('click', '.products table.table-items > tbody > tr', function () {
        window.location.replace($(this).find('.col-action a').attr('href'));
    });

    $(document).on('click', '.products table.table-related-products > tbody > tr', function () {
        window.location.replace($(this).find('.col-picture a').attr('href'));
    });
})();
/* End: products */

/* Begin: Contact form */
$(function () {
    $(document).on('submit', 'form.contact-form', function (e) {
        e.preventDefault();

        const that = $(this);
        const btn = that.find('[type="submit"]');
        const alertContainer = that.find('.alert-container');
        const alertTemplate = $(that.find('.alert-template').html()).clone();
        const isActiveCaptcha = that.find('.captcha-img').length > 0;

        alertContainer.find('.alert-process').remove();
        btn.prop('disabled', true);
        that.addClass('process');

        axios.post(that.attr('action'), that.serialize())
            .then((response) => {
                alertTemplate.addClass('alert-success').find('.inline').html(response.data.message);
                alertContainer.append(alertTemplate);

                that[0].reset();

                if (isActiveCaptcha) {
                    captchaRefresh(that.find('.captcha-img'), that.find('input[name="captcha"]'));
                }

                btn.prop('disabled', false);
                that.removeClass('process');
                $('html, body').animate({scrollTop: that.offset().top - 50}, 1000);
            })
            .catch((error) => {
                const response = error.response;

                const errors = [];
                if (response.status === 422) {
                    $.each(response.data.errors, function (i, v) {
                        errors.push(v[0]);
                    })
                } else {
                    errors.push(that.data('error-general'));
                }

                alertTemplate.addClass('alert-danger').find('.inline').html(errors.join('<br/>'));
                alertContainer.append(alertTemplate);

                if (isActiveCaptcha) {
                    captchaRefresh(that.find('.captcha-img'), that.find('input[name="captcha"]'));
                }

                btn.prop('disabled', false);
                that.removeClass('process');
                $('html, body').animate({scrollTop: that.offset().top - 50}, 1000);
                that.find('[name="name"]').focus();
            });
    });
});
/* Begin: Contact form */

/* Begin: Search dropdown */
$(function () {
    $('#search-dropdown').on('shown.bs.dropdown', function() {
        $(this).find('input[name="q"]').focus();
    });
});
/* End: Search dropdown */
